import { getPlanTemplateByIdUrl, getPlanTemplatesUrl } from "../config/Config";
import { deleteRequest, getRequest, postRequest } from "./ServiceHelper";

export class PlanTemplateService {
  static getTemplates = () => {
    return getRequest(getPlanTemplatesUrl());
  };

  static upsertTemplate = (template) => {
    return postRequest(getPlanTemplatesUrl(), template);
  };

  static deleteTemplate = (templateId) => {
    return deleteRequest(getPlanTemplateByIdUrl(templateId));
  };
}
